import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// Read admin enable flag from env; normalize to boolean
const enableAdmin = (process.env.VUE_APP_ENABLE_ADMIN || '').toLowerCase() === 'true'

// Build base routes first (non-admin)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('./views/HomeView/HomeView.vue'),
  },
  {
    path: '/market',
    redirect: '/market',
    component: () => import('./views/Layouts/app.layout.vue'),
    children: [
      {
        path: '',
        name: 'market',
        component: () => import('./views/App/market.vue'),
      },
      {
        path: '/claim',
        name: 'claim',
        component: () => import('./views/App/claim.vue'),
      },
      {
        path: '/detail/:id',
        name: 'market-detail',
        component: () => import('./views/App/market-detail.vue'),
      },
      {
        path: '/portfolio',
        name: 'portfolio',
        component: () => import('./views/App/portfolio.vue'),
      },
      {
        path: '/bridge',
        name: 'bridge',
        component: () => import('./views/TokenMove/index.vue'),
      },
      {
        path: '/deposit',
        name: 'deposit',
        component: () => import('./views/Fund/Deposit.vue'),
      },
      {
        path: '/issue',
        name: 'issue',
        component: () => import('./views/App/issue.vue'),
      },
    ],
  },
  {
    path: '/nft',
    component: () => import('./views/Layouts/app.layout.vue'),
    children: [
      {
        path: '',
        component: () => import('./views/NFT/layout.vue'),
        children: [
          {
            path: '',
            name: 'nftSale',
            component: () => import('./views/NFT/index.vue'),
          },
          {
            path: 'packet',
            name: 'nftPacket',
            component: () => import('./views/NFT/packet.vue'),
          },
          {
            path: 'market',
            name: 'nftMarket',
            component: () => import('./views/NFT/market.vue'),
          },
          {
            path: 'detail/:id',
            name: 'nft-detail',
            component: () => import('./views/NFT/nft-detail.vue'),
          },
        ],
      },
    ],
  },
]

// Conditionally add Admin route
if (enableAdmin) {
  routes.push({
    path: '/admin',
    name: 'Admin',
    component: () => import('./views/Admin/admin.vue')
  })
}

// Export router with the computed routes
export default new Router({
  mode: 'history',
  routes
})
